module.exports = __webpack_public_path__ + "img/octopus.a71de67c.svg";